<template>
  <div>
    <NotFound
      type="setup"
      btn="Ir para simulador"
      :btnFunction="handleEditar"
      title="Editar no simulador"
      text="Você será redirecionado para a página de configuração, lá você poderá editar todas as informações e realizar uma nova simulação. Selecione as turmas abaixo para fixar a alocação encontrada."
    />

    <div class="pa-12" v-if="plan.solution.status != 'Unfeasible'">
      <!-- Search box -->
      <div class="search pt-1 mb-2">
        <v-text-field
          v-model="editInfo.search"
          dense
          outlined
          rounded
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </div>
      <!-- List of classes -->
      <v-data-table
        :single-select="false"
        v-model="editInfo.selected"
        show-select
        :search="editInfo.search"
        :headers="editInfo.headers"
        :items-per-page="-1"
        :items="editInfo.data"
        item-key="idx"
        hide-default-footer
        class="elevation-1"
      >
        <!-- allow search without special characters -->
        <template v-slot:item.all="{ item }">
          <p class="mb-0">{{ item.codigo }}</p>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import latinize from "latinize";
import { handleEditSolution } from "@/api/paas";

import NotFound from "@/components/NotFound.vue";

export default {
  name: "HandleEditInSimulator",
  components: {
    NotFound
  },
  props: {
    plan: Object
  },
  data() {
    return {
      editInfo: {
        search: "",
        selected: [],
        data: [],
        headers: [
          { align: "start", text: "Código", value: "all" },
          { text: "Turma", value: "turma" },
          { text: "Nome", value: "nome" },
          { text: "Sala alocada", value: "sala_alocada" }
        ]
      }
    };
  },
  mounted() {
    let classes = [];

    this.plan.solution.solution.forEach(room => {
      room.classes.forEach(e => {
        let sala = `${room.bloco} ${room.nome}`;
        //allow search without special characters
        let dataLatinaze = latinize(`${sala} ${e.nome} ${e.docente}`);
        let all = `${sala} ${e.nome} ${e.docente} ${dataLatinaze}`;

        classes.push({
          ...e,
          sala_alocada: sala,
          idx: `${e.codigo}-${e.turma}`,
          all: all
        });
      });
    });

    this.editInfo.data = JSON.parse(JSON.stringify(classes));
  },
  methods: {
    handleEditar() {
      handleEditSolution(
        this.plan.solution,
        this.plan.name,
        this.editInfo.selected,
        this.$route.query.demo == "1"
          ? null
          : this.plan.id || this.$route.params.id
      );
      this.$router.push({ path: "/paas-simulador" });
    }
  }
};
</script>

<style scoped>
.search {
  width: 30%;
}
</style>
